/* eslint-disable react/no-multi-comp */
import { ModelIcon } from '@velasca/icons/model'
import {
  BulletContainer,
  Container,
  Image,
  ModelIconWrapper,
  StyledBullet,
  StyledBulletSquared,
} from './Thumbnail.styles'
import type { PolaroidProps, ThumbnailProps } from './Thumbnail.types'

export const Thumbnail = ({
  onClick,
  imageSrc,
  imageAlt,
  rotationDegrees,
}: ThumbnailProps): JSX.Element => {
  return (
    <Container onClick={onClick}>
      <Image
        src={imageSrc}
        alt={imageAlt}
        draggable={false}
        rotationDegrees={rotationDegrees}
      />
    </Container>
  )
}

export const Polaroid = ({
  imageSrc,
  imageAlt,
  onClick,
  rotationDegrees,
}: PolaroidProps): JSX.Element => {
  return (
    <Container polaroid onClick={onClick}>
      <Image
        polaroid
        src={imageSrc}
        alt={imageAlt}
        draggable={false}
        rotationDegrees={rotationDegrees}
      />
    </Container>
  )
}

export const Bullet = ({ onClick }: { onClick: () => void }): JSX.Element => {
  return (
    <BulletContainer onClick={onClick}>
      <StyledBullet />
    </BulletContainer>
  )
}

export const BulletSquared = ({
  onClick,
}: {
  onClick: () => void
}): JSX.Element => {
  return <StyledBulletSquared onClick={onClick} />
}

export const Model = ({ onClick }: { onClick: () => void }): JSX.Element => {
  return (
    <Container onClick={onClick}>
      <ModelIconWrapper>
        <ModelIcon />
      </ModelIconWrapper>
    </Container>
  )
}
